module.exports = __webpack_public_path__ + "img/50.ed246022.svg";